import React from "react";
import { t } from "i18next";
import moment from "moment/moment";
import {
	Button,
	Drawer,
	Spin,
	InputTextArea
} from "common/elements";
import { Util } from "common/util";
import {
	approveAndRejectOvertimeReuest,
	getOne,
} from "services/overtime_request";
import Enum from "common/enums";

function RowItem({ title, value }) {
	return <div style={{ display: "flex", justifyItems: "center", justifyContent: "space-between", marginTop: 5 }}>
		<div className="ant-form-item-label" style={{ width: 165 }}>
			<label>{title}</label>
		</div>
		<div style={{ border: "1px solid #d9d9d9", borderRadius: 4, height: 32, lineHeight: "32px", flexGrow: 1, paddingLeft: 10 }}>
			{value}
		</div>
	</div>
}
export default class FormReview extends React.Component {
	state = {
		loading: false,
		visible: false,
		formData: {},
		comment: "",
		commentStatus: ""
	};

	componentDidMount() {
		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has("overtimeId")) {
			this.showDrawer(queryParams.get("overtimeId"));
		};
	}

	showDrawer = (id) => {
		this.setState({ loading: true, visible: true });
		getOne(id)
			.then((response) => {
				if (response) {

					this.setState({
						formData: response,
						loading: false,
					});
				}
			})
			.catch(error => {
				if (error.response.status === 403) {
					localStorage.removeItem("ACCESS_TOKEN");
					this.props.navigate("/signin");
				}
			})
			.finally(() => {
				this.setState({ loading: false });
			});
	};

	onClose = () => {
		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has("overtimeId")) {
			queryParams.delete("overtimeId");
			Util.getInstance().pushParamsToURL("/overtime-request", queryParams.toString());
		}
		this.setState({
			visible: false,
			loading: false,
			formData: {}
		});
	};

	onFinish = (values) => {
		this.handleUpdateStatusButton(
			this.state.formData.id,
			Enum.LEAVESTATUS.REJECTED,
			values
		);
	};

	handleApprove = () => {
		Util.getInstance()
			.sweetAlertConfirm(t("text_confrim"), "Once approved, you will not be able to rollback this OT!")
			.then((willApprove) => {
				if (willApprove) {
					this.setState({
						submitting: true
					});
					approveAndRejectOvertimeReuest(this.state.formData.id, { status: 1 })
						.then(() => {
							this.props.onSuccess();
							window.location.reload();
							this.onClose();
						})
						.finally(() => {
							this.setState({
								submitting: false,
								visible: false
							});
						});
				}
			});
	};

	handleReject = () => {
		if (!this.state.comment) {
			this.setState({ commentStatus: "ant-input-status-error" });
			return;
		}

		Util.getInstance()
			.sweetAlertConfirm(t("text_confrim"), "Once rejected, you will not be able to rollback this OT!")
			.then((willReject) => {
				if (willReject) {
					this.setState({ rejecting: true });

					approveAndRejectOvertimeReuest(this.state.formData.id, {
						overTimeRequestId: this.state.formData.id,
						status: 2,
						comment: this.state.comment
					})
						.then(() => {
							this.props.onSuccess();
							window.location.reload();
							this.onClose();
						})
						.finally(() => {
							this.setState({
								rejecting: false
							});
						});
				}
			});
	};

	render() {
		const {
			visible,
			formData,
			rejecting,
			submitting,
			loading
		} = this.state;

		const employeeCode = JSON.parse(localStorage.getItem("ACCESS_TOKEN")).profile.code;

		return <>
			<Drawer
				placement="right"
				id="leave-drawer"
				closable={true}
				visible={visible}
				onClose={this.onClose}
				width={600}
				title="Overtime Request"
			>
				{
					loading ? <Spin spinning={loading} className="leave-loading"></Spin> : Object.keys(formData).length === 0 ? <></>
						:
						<>
							<div style={{ height: document.documentElement.offsetHeight - 110, overflowY: "auto", paddingLeft: 25, paddingRight: 25 }}>
								<div style={{ marginTop: 25 }} />
								<RowItem title={t("text_request_no")} value={formData.requestNo} />
								<RowItem title={t("text_staff_id")} value={formData.employeeCode} />
								<RowItem title={t("text_staff_name")} value={formData.employeeName} />
								<RowItem title={t("text_staff_email_id")} value={formData.staffEmailId} />
								<RowItem title={"OT From"} value={moment(formData.startDate).format("ddd DD MMM")} />
								<RowItem title={"OT To"} value={moment(formData.endDate).format("ddd DD MMM")} />
								<RowItem title={"Request For"} value={formData.type === "FOR_LEAVE" ? "Compensation Leave" : "For Payment"} />
								<RowItem title={t("text_number_day")} value={formData.numberOfDay} />
								{formData.reason &&
									<div style={{ display: "flex", justifyItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
										<div className="ant-form-item-label" style={{ width: 165, display: "flex", alignItems: "center" }}>
											<label>{t("text_reason")}</label>
										</div>
										<div style={{ border: "1px solid #d9d9d9", borderRadius: 4, height: 100, flexGrow: 1, paddingLeft: 10, paddingTop: 5 }}>
											{formData.reason}
										</div>
									</div>
								}
								<RowItem title={t("text_requested_date")} value={moment(formData.requestedDate).format("ddd DD MMM, YYYY")} />
								<RowItem title={t("text_approval_id")} value={formData.userName} />
								<div className="form-input">
									<div className="ant-form-item-label" style={{ width: 165 }}>
										<label className="ant-form-item-required">{t("text_hr_comment")}</label>
									</div>
									<div style={{ flexGrow: 1 }}>
										<InputTextArea
											name="comment"
											className={this.state.commentStatus}
											defaultValue={formData.comment}
											requiredMessage={t("text_what_is_your_reject_reason")}
											placeholder={t("text_tell_requestor_about_rejected_reason_here")}
											onChange={e => this.setState({ comment: e.target.value, commentStatus: "" })}
											style={{ height: 136 }}
										/>
										{
											this.state.commentStatus &&
											<div className="ant-form-item-explain">
												<div role="alert" className="ant-form-item-explain-error">Please enter your rejected reason!</div>
											</div>
										}
									</div>
								</div>
							</div>
							{
								employeeCode !== formData.employeeCode &&
								<div id="leave-btn" className="btn-footer" style={{ display: "flex", justifyContent: "flex-end" }}>
									{
										formData.status === Enum.LEAVESTATUS.REQUESTED && !Util.getInstance().hasNoPermission("approve", "overtime request") &&
										<Button
											className="btn-form btn-rejected"
											onClick={this.handleReject}
											loading={rejecting}
											disabled={submitting || rejecting}
											style={{ width: 130 }}
										>
											{t("text_reject")}
										</Button>
									}

									{
										formData.status === Enum.LEAVESTATUS.REQUESTED && !Util.getInstance().hasNoPermission("approve", "overtime request") &&
										<Button
											className="btn-form btn-approved"
											type="primary"
											onClick={this.handleApprove}
											loading={submitting}
											disabled={submitting || rejecting}
											style={{ width: 130 }}
										>
											{t("text_approve")}
										</Button>

									}
								</div>
							}
						</>
				}
			</Drawer>
		</>;
	}
}
